import SessionFeeView from './components/session-fees-view';

export default SessionFeeView;
